import { MainWrapper } from '@app/components/layout/main-wrapper/MainWrapper';
import { Sidenav } from '@app/components/layout/sidenav/Sidenav';
import { GlobalLivePlayer } from '@app/features/global-live-player/GlobalLivePlayer';
import { ModulesNavLinks } from '@app/modules/links';
import { ModulesRoutes } from '@app/modules/ModulesRoutes';
import { getBrowserTimezone } from '@mi-front/core';
import { parseAsBoolean, useQueryState } from 'nuqs';
import { memo } from 'react';
import { useAuth } from '../auth/authentication/hooks';
import { useUserLocaleCheck } from '../auth/profile/hooks/useUserLocaleCheck';
import { TimezoneCtxProvider } from '../context/timezone';
import { useTestError } from '../hooks/useTestError';
import { IntegrationsTracking } from '../integrations/IntegrationsTracking';
import { UrlMediaPlayer } from '../media-player/UrlMediaPlayer';
import { UrlMediaPlayerProvider } from '../media-player/useUrlMediaPlayer';
import { VersionChecker } from '../version-check/VersionChecker';
import { AppReadyTracking } from './AppReadyTracking';

export const App = memo(() => {
  useTestError();
  useUserLocaleCheck();

  const [isFullscreen] = useQueryState('fullscreen', parseAsBoolean);
  const auth = useAuth();

  return (
    <IntegrationsTracking>
      <VersionChecker />
      <UrlMediaPlayerProvider>
        <TimezoneCtxProvider
          value={{
            timezone: getBrowserTimezone(),
          }}
        >
          <AppReadyTracking />
          <MainWrapper
            sidenav={
              isFullscreen ? null : (
                <Sidenav>{auth.isSuperadmin ? null : <ModulesNavLinks />}</Sidenav>
              )
            }
            content={<ModulesRoutes />}
          />
        </TimezoneCtxProvider>
        <UrlMediaPlayer />
        <GlobalLivePlayer />
      </UrlMediaPlayerProvider>
    </IntegrationsTracking>
  );
});
